import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Reservations',
		url: '/reservations',
		icon: 'calendar-check-o',
	},
];

export default class Reservations extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalReservation')} size="sm" color="primary">
						<i className="fa fa-calendar-check-o"/>&nbsp;&nbsp;Add Reservation
					</Button>
				</Framework.Components.PageBar>

				<Collections.Reservations
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					scannedCode={!this.state['modalReservation'] ? this.props.scannedCode : null}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Reservation"
					object={Objects.Reservation}
					history={this.props.history}
					toggle={this.state['modalReservation']}
					reportClose={this.reportClose('modalReservation')}
					afterSave={this.handleAfterSave}
					size="xl"
					objectProps={{scannedCode: this.state['modalReservation'] ? this.props.scannedCode : null}}
				/>

			</div>
		);
	}
}

